import 'mlmi-library'
import { CoreDetect_WebP } from 'mlmi-library/utils/device'
import Burger from 'mlmi-library/components/burger/v1/burger'
import Mobile from 'mlmi-library/modules/mobile/v1/mobile'
import Carousel, { Carousel_CoreInit } from 'mlmi-library/components/carousel/v1/carousel'
import Form from 'mlmi-library/components/form/v1/form'
import { Form_CoreInit } from 'mlmi-library/components/form/v1/form-builder'
import 'mlmi-library/components/fade-in/v2/fade-in'

export { Burger, Carousel, Carousel_CoreInit, Form_CoreInit, Mobile }

CoreDetect_WebP()
